var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loading-container"},[_c('b-icon',{staticClass:"spin",attrs:{"icon":"loading","size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }